import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppFilter } from "app/models/app-filter.model";
import { DomSanitizer } from '@angular/platform-browser';
import { AbInadimplente } from 'app/abstract/full-pages/inadimplente/inadimplente.abstract';


@Injectable({ providedIn: 'root' })
export class InadimplentService extends AbInadimplente {

  constructor(http: HttpClient, private sanitizer: DomSanitizer) {
    super(http);
  }

  public getAllInadimplentes(filter: AppFilter): Observable<any> {
    return this.get(`inadimplentes/filter/${filter.encode()}`);
  }

  public saveInadimplentes(inadimplente: any): Observable<any> {
    return this.save("inadimplentes/", inadimplente);
  }

  public retirarPendencia(id: any): Observable<any> {
    return this.save("inadimplentes/retirar_pendencia/", id);
  }

  public deletar(id: number) {
    return this.delete("inadimplentes/", id);
  }

  public getById(id: number): Observable<any> {
    return this.get(`inadimplentes/${id}`);
  }

  public getResponsavelByUnidadeId(unidadeId: number) {
    return this.get(`inadimplentes/responsavel_unidade/`, unidadeId);
  }

}
